<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showNewTipoAlterno"
      scrollable
      no-close-on-backdrop
      size="sm"
      title="Nuevo Tipo Jugador "
      cancel-variant="outline-secondary"
    >
      <b-list-group>
        <b-list-group-item
          class="d-flex"
          v-for="item in listTipos"
          :key="item.id"
        >
          <div class="font-weight-bold d-block text-nowrap">
            {{ item.tipo_alterno }}
          </div>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            size="sm"
            class="ml-3"
            @click="insertNuevoTipo(item)"
          >
            Agregar
          </b-button>
        </b-list-group-item>
      </b-list-group>
      <br />
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col class="mt-1">
              <template v-if="!showLoading">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="outline-primary"
                  class="float-right mr-1"
                  @click="onlyClose"
                >
                  Cancelar
                </b-button>
              </template>
              <div v-if="showLoading" class="text-center mt-1">
                <b-spinner variant="primary" label="Text Centered" />
              </div>
            </b-col>
          </b-row>
          <b-alert
            :show="dismissCountDown"
            v-height-fade.appear
            :variant="variante"
            style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
            @dismiss-count-down="countDownChanged"
          >
            <div
              :class="{
                'alert-body danger': variante == 'danger',
                'alert-body success': variante == 'success',
              }"
            >
              {{ messageError }}
            </div>
          </b-alert>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  // BBadge,
  BButton,
  BListGroup,
  BListGroupItem,
  // BFormTextarea,
  // BFormSpinbutton,
  BSpinner,
  BAlert,
  // BFormRadio,
  // BFormCheckbox,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import store from '@/store'
import {
  URL,
  USER,
  ROLES,
  // xxx,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    // BBadge,
    BButton,
    // BFormTextarea,
    // BFormSpinbutton,
    BSpinner,
    BAlert,
    // BFormRadio,
    // BFormCheckbox,
  },
  // props: {
  //   dataPartido: Object,
  //   idEquipo: String,
  // },
  props: {
    listTipos: Array,
    categoria: String,
  },
  directives: {
    Ripple,
    // 'b-tooltip': VBTooltip,
    heightFade,
  },
  setup(props, { emit }) {
    const showLoading = ref(false)
    const messageError = ref(null)
    const dismissCountDown = ref(0)
    const variante = ref('danger')

    const dismissSecs = ref(3)
    const { postApi } = apiCall()
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      // hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }

    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_MOTIVO', false)
    }
    async function insertNuevoTipo(item) {
      const dataSend = {
        id_categoria: props.categoria,
        id_tipo: item.id_tipo_jugador_alterno,
        name_tipo: item.tipo_alterno,
      }
      showLoading.value = true
      const path = 'ApiConfiguration/insertTipoAlternoEnCategoria'
      const response = await postApi(URL, path, dataSend)
      // console.log(response)
      if (response.flag === 'si') {
        // emit('fijoAgregado', response.respuesta)
        emit('tipoAgregado', { antiguo: item, agregado: response.respuesta })
        // store.commit('someVariables/UPDATE_SHOW_NEW_VALOR_FIJO', false)
        showMessageAlert('success', 'Agregado exitosamente')
        // onlyClose()
      } else {
        showMessageAlert('danger', response.mensaje)
        variante.value = 'danger'
        dismissCountDown.value = dismissSecs.value
      }
      showLoading.value = false
    }
    return {
      insertNuevoTipo,
      showLoading,
      messageError,
      onlyClose,
      countDownChanged,
      dismissCountDown,
      dismissSecs,
      USER,
      ROLES,
      variante,
    }
  },
}
</script>
